import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, makeStyles, Button, } from '@material-ui/core';
import clsx from 'clsx';
import { FontIcon, } from '..';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: theme.spacing(1),
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(2),
            },
        },
        icon: {
            fontSize: '3em',
            marginBottom: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
                fontSize: '4em',
            },
        },
        title: {
            marginBottom: theme.spacing(1),
            textAlign: 'center',
            fontSize: '1.5em',
            [theme.breakpoints.up('md')]: {
                fontSize: '2em',
            },
        },
        message: {
            textAlign: 'center',
            fontSize: '1em',
            [theme.breakpoints.up('md')]: {
                fontSize: '1.5em',
            },
        },
        action: {
            marginTop: theme.spacing(1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            '& button': {
                fontSize: 'smaller',
            },
            [theme.breakpoints.up('md')]: {
                marginTop: theme.spacing(2),
                '& button': {
                    fontSize: 'unset',
                },
            },
        },
    };
}, {
    name: 'GenericMessageBox',
});
export const GenericMessageBox = (props) => {
    var _a, _b, _c;
    const classes = useStyle();
    return (_jsxs("div", { className: clsx(classes.root, props.className), style: props.style, children: [props.icon && (_jsx(FontIcon, { className: classes.icon, iconName: props.icon, color: props.iconColor })), props.title
                && _jsx(Typography, { variant: "h4", color: (_a = props.titleColor) !== null && _a !== void 0 ? _a : 'textPrimary', className: classes.title, children: props.title }), props.message
                && _jsx(Typography, { variant: "h5", color: (_b = props.messageColor) !== null && _b !== void 0 ? _b : 'textPrimary', className: classes.message, children: props.message }), props.action && props.actionHandler && (_jsx("div", { className: classes.action, children: _jsx(Button, { variant: (_c = props.actionVariant) !== null && _c !== void 0 ? _c : 'contained', color: props.actionColor ? props.actionColor : 'primary', onClick: props.actionHandler, children: props.action }) }))] }));
};
